import paymentSaga from './paymentSaga';

export default paymentSaga;
